import React from 'react';

function ServiceIcons({ onServiceClick, onEventClick, onWithdrawalClick, onDepositClick, onTermsClick, onFAQsClick, onAboutClick, onCertificateClick }) {
  const services = [
    { icon: 'bi-diagram-3', label: 'Service' },
    { icon: 'bi-calendar-check', label: 'Event' },
    { icon: 'bi-arrow-down-circle', label: 'Withdrawal' },
    { icon: 'bi-arrow-up-circle', label: 'Deposit' },
    { icon: 'bi-file-text', label: 'T & C' },
    { icon: 'bi-award', label: 'Certificate' },
    { icon: 'bi-chat-dots', label: 'FAQs' },
    { icon: 'bi-info-circle', label: 'About' },
  ];

  const handleServiceClick = (service) => {
    if (service.label === 'Service' && onServiceClick) {
      onServiceClick();
    } else if (service.label === 'Event' && onEventClick) {
      onEventClick();
    } else if (service.label === 'Withdrawal' && onWithdrawalClick) {
      onWithdrawalClick();
    } else if (service.label === 'Deposit' && onDepositClick) {
      onDepositClick();
    } else if (service.label === 'T & C' && onTermsClick) {
      onTermsClick();
    } else if (service.label === 'FAQs' && onFAQsClick) {
      onFAQsClick();
    } else if (service.label === 'About' && onAboutClick) {
      onAboutClick();
    } else if (service.label === 'Certificate' && onCertificateClick) {
      onCertificateClick();
    }
  };

  return (
    <div className="container-fluid px-3 py-3">
      <div className="service-section">
        <div className="row g-2">
          {services.map((service, index) => (
            <div key={index} className="col-3">
              <div 
                className="service-btn"
                onClick={() => handleServiceClick(service)}
              >
                <i className={`bi ${service.icon} fs-3 text-purple mb-2`}></i>
                <div className="service-label">{service.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServiceIcons;

